import { useEffect, useState } from "react";
import { Alert, AlertColor } from "@mui/material";
import localisations from "domains/allocations/localisation";
import { useQuerySnapshot } from "domains/allocations/services/use-allocation-api";
import { QuerySnapshotOptions, QuerySnapshotResponse } from "domains/allocations/services/allocation-service";

interface IProductQuantityStatusProps {
    productId: number | null;
    partitionId: string;
    quantity: number | null;
    onLoaded?: (status: boolean) => void;
    formatMessage?: (status: boolean) => string;
    validStock: (data: QuerySnapshotResponse) => boolean;
}

const InnerProductQuantityStatus = (props: IProductQuantityStatusProps) => {
    let options = { partitionId: props.partitionId } as QuerySnapshotOptions;
    const { loading, data, error, refresh } = useQuerySnapshot(options);
    const { onLoaded, formatMessage } = props;
    const [hasSufficientStock, SetSufficientStock] = useState(false);
    const statusSeverity = (status: boolean): AlertColor => (status ? "success" : "info");
    const defaultFormatMessage = (status: boolean): string => status ? localisations.transferStock.sufficientQuantityStatus : localisations.transferStock.insufficientQuantityStatus;
    const messageToDisplay = formatMessage || defaultFormatMessage;

    useEffect(() => {
        if (data && props) {
            SetSufficientStock(props.validStock(data));
        }
    }, [data, props]);

    useEffect(() => {
        if (!loading && !error && data) {
            if (onLoaded) {
                onLoaded(hasSufficientStock);
            }
        }
    }, [loading, data, error, onLoaded, hasSufficientStock]);

    return (
        <>
        {(!loading && data && props.quantity != null && props.productId != null) === true &&
            <Alert severity={statusSeverity(hasSufficientStock)}>{messageToDisplay(hasSufficientStock)}</Alert>}
        </>
    );
};

const ProductQuantityStatus = (props: IProductQuantityStatusProps) => {

    return (
        <InnerProductQuantityStatus
            validStock={props.validStock}
            productId={props.productId}
            partitionId={props.partitionId}
            quantity={props.quantity}
            onLoaded={props.onLoaded}
            formatMessage={props.formatMessage}
        ></InnerProductQuantityStatus>
    );
};

export default ProductQuantityStatus;